import { useEffect, useRef, useMemo } from 'react';
import { type GeolocationPosition, type MapBounds } from '@inloco/shared';
import { useNotifications } from '../context';
import { useTranslation } from "react-i18next";

export const useMapBoundsCheck = (position: GeolocationPosition | null, bounds: MapBounds | null) => {
    const { addNotification } = useNotifications();
    const { t } = useTranslation();
    const wasInsideRef = useRef<boolean>(true);

    const isWithinBounds = useMemo(() => {
        if (!position || !bounds) return true;

        const BUFFER = 0.00015;
        const { lt, lg } = position;
        const { ne, sw } = bounds;

        return (
            lt <= ne.lt + BUFFER && lt >= sw.lt - BUFFER &&
            lg <= ne.lg + BUFFER && lg >= sw.lg - BUFFER
        );
    }, [position, bounds]);

    useEffect(() => {
        // Notifica solo sulla transizione DENTRO -> FUORI
        if (position && wasInsideRef.current && !isWithinBounds) {
            addNotification({
                message: t('map.outOfBounds'),
                type: 'warning',
                duration: 0,
                closable: false
            });
        }

        // Se abbiamo una posizione, aggiorniamo il ref dello stato precedente
        if (position) {
            wasInsideRef.current = isWithinBounds;
        }
    }, [isWithinBounds, position, addNotification, t]);

    return isWithinBounds;
};